var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.short && _vm.name),expression:"short && name"}],staticClass:"region-stamp code",attrs:{"data-original-text":_vm.name},domProps:{"textContent":_vm._s(_vm.code)}})
}
var staticRenderFns = []

export { render, staticRenderFns }